import React from 'react';
import { CandidateFilterMatchMode } from 'modules/candidate-profile/types/CandidateSearchFilter';
import { CandidateProfileChip } from 'modules/candidate-profile/components/CandidateProfileChip';

const MODE_PREFIX: Record<CandidateFilterMatchMode, (label: string) => string> =
  {
    [CandidateFilterMatchMode.INCLUDE_ANY]: (label) => `Any ${label} from:`,
    [CandidateFilterMatchMode.INCLUDE_ALL]: (label) => `All ${label}:`,
    [CandidateFilterMatchMode.EXCLUDE]: (label) => `Exclude ${label}:`
  };

export const filterChipPrefix = (
  mode: CandidateFilterMatchMode,
  label: string,
  isSearch = false,
  // A radius or a range holds one value and no mode, so "Any X from:" would be
  // describing a choice the recruiter was never offered.
  hideMode = false
): string => {
  if (hideMode) return `${label}:`;

  return isSearch ? `${label} contains:` : MODE_PREFIX[mode](label);
};

type CandidateFilterChipProps = {
  mode: CandidateFilterMatchMode;
  label: string;
  values: string[];
  isSearch?: boolean;
  hideMode?: boolean;
  onDelete: () => void;
};

export const CandidateFilterChip: React.FC<CandidateFilterChipProps> = ({
  mode,
  label,
  values,
  isSearch = false,
  hideMode = false,
  onDelete
}) => (
  <CandidateProfileChip
    prefix={filterChipPrefix(mode, label, isSearch, hideMode)}
    label={values.join(', ')}
    isNegative={mode === CandidateFilterMatchMode.EXCLUDE}
    onDelete={onDelete}
    wrap
  />
);
